<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    customHeight="h-112"
    customWidth="lg:w-120"
  >
    <template #modal-header>
      <div class="">
        <div class="flex items-center">
          <Icon name="Check" class="w-4 h-4 mr-1 stroke-info" />
          <div class="text-sm font-inter font-semibold text-info">Confirm</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          Opt-Out of Trusted Contact Form
        </div>
      </div>
    </template>

    <template #modal-body>
      <div class="p-6 text-error text-lg">
        You are choosing to decline designating a Trusted Contact Person at this time. As a result,
        any previously designated Trusted Contacts will be removed from your account.
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleConfirm()" variant="primary-grey" size="sm" class="">
          <template #label>Confirm</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
//IMPORTS
import { Modal, Icon, Button } from "@/components";
import { useCrudStore, useDataStore, useSchemaStore, useUIStore } from "@/stores";

//STORES
const crudStore = useCrudStore();
const dataStore = useDataStore();
const schemaStore = useSchemaStore();
const UIStore = useUIStore();

//EMITS AND PROPS
const emit = defineEmits(["close-modal", "confirm"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

// COMPONENT LOGIC AND FUNCTIONS
async function handleConfirm() {
  try {
    dataStore.contact.opted_out_trusted_contact_form = true;

    let query = [
      {
        field_name: "record_id",
        operator: "eq",
        value: dataStore.contact.record_id,
      },
    ];

    let update = {
      opted_out_trusted_contact_form: true,
    };

    update = schemaStore.addCreatedUpdatedFields(update, false, true);

    let update_response = await crudStore.update("contacts", query, update);

    if (update_response.status !== 200) {
      throw new Error("Failed to update contact with opt-out of trusted contact form");
    }

    let delete_query = [
      {
        field_name: "user_id",
        operator: "eq",
        value: dataStore.contact.user_id,
      },
    ];

    await crudStore.delete("trustedcontacts", delete_query);

    emit("confirm", {
      type: "trusted_contact",
      record_id: null,
    });

    emit("close-modal");
  } catch (error) {
    var alert = {
      type: "error",
      message: `Failed to opt-out of Trusted Contact Form.`,
    };
    UIStore.animateNotificationAlert(alert);
    emit("close-modal");
  }
}
</script>
